import { render, staticRenderFns } from "./VErrors.vue?vue&type=template&id=0086bcae"
import script from "./VErrors.vue?vue&type=script&lang=js"
export * from "./VErrors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports